import Tools from 'helpers/Tools';

const draggable = (element, config = {}, disabled = false) => {
	let {
		step = false,
		stepX = false,
		stepY = false,
		minX = false,
		minY = false,
		maxX = false,
		maxY = false
	} = config;

	if (step) {
		stepX = step;
		stepY = step;
	}

	let isMouseDown = false;

	let mouseX;
	let mouseY;

	let elementX = 0;
	let elementY = 0;

	let startLeft = parseInt(element.style.left) || 0;
	let startTop = parseInt(element.style.top) || 0;

	const mouseDown = (event) => {
		mouseX = event.clientX - startLeft;
		mouseY = event.clientY - startTop;
		isMouseDown = true;
	};

	const mouseUp = (event) => {
		isMouseDown = false;
		elementX = 0;
		elementY = 0;
		startLeft = parseInt(element.style.left) || 0;
		startTop = parseInt(element.style.top) || 0;
	};

	const mouseMove = (event) => {
		if (!isMouseDown) return;
		var deltaX = event.clientX - mouseX;
		var deltaY = event.clientY - mouseY;
		//step
		let nextX = elementX + deltaX;
		let nextY = elementY + deltaY;

		if (stepX) {
			nextX = Tools.round(nextX, stepX);
		}
		if (stepY) {
			nextY = Tools.round(nextY, stepY);
		}

		if (minX !== false && nextX < minX) {
			nextX = minX;
		}
		if (minY !== false && nextY < minY) {
			nextY = minY;
		}

		if (maxX !== false && nextX > maxX) {
			nextX = maxX;
		}
		if (maxY !== false && nextY > maxY) {
			nextY = maxY;
		}

		element.style.left = nextX + 'px';
		element.style.top = nextY + 'px';
	};


	element.removeEventListener('mousedown', mouseDown);
	element.removeEventListener('mouseup', mouseUp);
	document.removeEventListener('mousemove', mouseMove);

	if (disabled) {
		return;
	}

	element.ondragstart = function () {
		return false;
	};
	element.addEventListener('mousedown', mouseDown);
	element.addEventListener('mouseup', mouseUp);
	document.addEventListener('mousemove', mouseMove);

}
export default draggable;
